import React from "react";
import { CustomButton, IconComponent, icon } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import styles from "./LogoEmptyState.module.css";

export default function LogoEmptyState({ onUpload }) {
	return (
		<div className={styles.emptyState}>
			<IconComponent className={styles.emptyState__icon} icon={icon.faImage} size="3xl" />
			<div className={styles.emptyState__title}>{translate("admin.company-logo.empty-state.title")}</div>
			<div className={styles.emptyState__subtitle}>{translate("admin.company-logo.empty-state.subtitle")}</div>
			<CustomButton color="primary" component="label" variant="contained">
				<input
					hidden
					accept="image/png,image/jpeg,image/jpg,image/gif,image/webp"
					className={styles.hiddenInput}
					id="logo-upload-empty"
					type="file"
					onChange={onUpload}
				/>
				<IconComponent color="var(--color-white)" icon={icon.faFileUpload} />
				{translate("admin.company-logo.btn.upload")}
			</CustomButton>
		</div>
	);
}
